import request from '@/utils/request'
import store from '@/store'
export function getViewInfo () {
  return request({
    url: '/api/discover',
    method: 'get',
    params: {viewCode: store.getters.viewId}
  })
}
